import { Form, Button, Modal, Alert } from "react-bootstrap";
import { store } from "../../reducer/Store";
import React from "react";
const OperationModalRegisterOrUpdate = ({
  controlFormId,
  showOperation,
  addOrUpdateOperation,
  selectOperation,
  setSelectOperation,
  selectPrestataire,
  setSelectPrestataire,
  monthOne,
  setMonthOne,
  monthTwo,
  setMonthTwo,
  monthThree,
  setMonthThree,
  selectOffre,
  setSelectOffre,
  descriptionOtherOffer,
  setDescriptionOtherOffer,
  isCheckedComTool,
  handleOnChangeComTool,
  isCheckedMerchandising,
  handleOnChangeMerchandising,
  operationMerchandisingData,
  operationCommunicationToolsData,
  handleQuantityMerchandising,
  commentOperation,
  setCommentOperation,

  animationsOperation,
  setAnimationsOperation,

  handleClose,
  errorMessageMonths,
  listPlvs,
  listPrestataires,
}) => {
  const { state } = React.useContext(store);
  const [formData] = React.useState({
    selectOperation: selectOperation || "",
    monthOne: monthOne.toString() || "",
    monthTwo: monthTwo.toString() || "",
    monthThree: monthThree.toString() || "",
    selectOffre: selectOffre.toString() || "",
    descriptionOtherOffer: descriptionOtherOffer || "",
    isCheckedComTool: isCheckedComTool || "",
    isCheckedMerchandising: isCheckedMerchandising || "",
    operationCommunicationToolsData: operationCommunicationToolsData || "",
    operationMerchandisingData: operationMerchandisingData || "",
    commentOperation: commentOperation || "",
  });
  const [newFormData, setNewFormData] = React.useState({
    ...formData,
  });
  const handleInputChange = (e, key = "", id = "") => {
    if (e.target.name === "selectOffre" && e.target.value !== "autre") {
      setNewFormData((prevData) => {
        return {
          ...prevData,
          selectOffre: e.target.value,
          descriptionOtherOffer: "",
        };
      });
    } else if (e.target.name === "monthOne" && e.target.value === "") {
      setNewFormData((prevData) => {
        return { ...prevData, monthOne: "", monthTwo: "", monthThree: "" };
      });
    } else if (e.target.name === "monthTwo" && e.target.value === "") {
      setNewFormData((prevData) => {
        return { ...prevData, monthTwo: "", monthThree: "" };
      });
    } else if (
      e.target.name === "isCheckedComTool" ||
      e.target.name === "isCheckedMerchandising" ||
      e.target.name === "operationMerchandisingData"
    ) {
      if (
        e.target.name === "isCheckedMerchandising" &&
        e.target.value === "false"
      ) {
        setNewFormData((prevData) => {
          return {
            ...prevData,
            operationMerchandisingData: prevData.operationMerchandisingData.map(
              (elt) =>
                elt.operation_plv_id === id ? { ...elt, quantity: 1 } : elt
            ),
          };
        });
      }
      setNewFormData((prevData) => {
        return {
          ...prevData,
          [e.target.name]:
            e.target.name === "isCheckedComTool"
              ? prevData.isCheckedComTool.map((check, i) =>
                  i === key ? !check : check
                )
              : e.target.name === "isCheckedMerchandising"
              ? prevData.isCheckedMerchandising.map((check, i) =>
                  i === key ? !check : check
                )
              : prevData.operationMerchandisingData.map((elt) =>
                  elt.operation_plv_id === key
                    ? { ...elt, quantity: parseInt(e.target.value) }
                    : elt
                ),
        };
      });
    } else {
      setNewFormData({ ...newFormData, [e.target.name]: e.target.value });
    }
  };
  const handleModalHide = () => {
    var windowConfirm = false;
    if (JSON.stringify(formData) !== JSON.stringify(newFormData)) {
      windowConfirm = true;
    }
    if (windowConfirm) {
      if (
        window.confirm(
          "Vous avez effectué des changements, êtes vous sûr de vouloir quitter sans valider ?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  //console.log(listPlvs);

  return (
    <Modal
      size="lg"
      show={showOperation}
      onHide={() => handleModalHide()}
      centered
    >
      <Form
        onSubmit={(e) => {
          addOrUpdateOperation(e);
        }}
      >
        <Modal.Header closeButton>
          <div className="row w100 me-2">
            <div className="col-md-6">
              <Form.Group controlId={`select-operation-type`}>
                <Form.Select
                  disabled={state.operationsType.length === 0 ? true : false}
                  size="lg"
                  required
                  value={selectOperation}
                  name="selectOperation"
                  onChange={(e) => {
                    handleInputChange(e);
                    setSelectOperation(e.target.value);
                  }}
                >
                  {state.operationsType.length === 0 ? (
                    <option value="">
                      Aucune opération type pour la marque
                    </option>
                  ) : (
                    <>
                      <option value="">Sélectionnez une opération</option>
                      {state.operationsType.map((opeType, key) => (
                        <option key={key} value={opeType.id}>
                          {`${opeType.brand.name.toUpperCase()} - ${
                            opeType.name
                          }`}
                        </option>
                      ))}
                    </>
                  )}
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-2">
              <Form.Group controlId={`select-month-one`}>
                <Form.Select
                  size="lg"
                  required
                  disabled={state.operationsType.length === 0 ? true : false}
                  value={monthOne}
                  name="monthOne"
                  onChange={(e) => {
                    if ("" === e.target.value) {
                      setMonthTwo("");
                      setMonthThree("");
                    }
                    handleInputChange(e);
                    setMonthOne(e.target.value);
                  }}
                >
                  <option value="">Mois 1</option>
                  {monthThree !== "1" && monthTwo !== "1" && (
                    <option value="1">Janvier</option>
                  )}
                  {monthThree !== "2" && monthTwo !== "2" && (
                    <option value="2">Février</option>
                  )}
                  {monthThree !== "3" && monthTwo !== "3" && (
                    <option value="3">Mars</option>
                  )}
                  {monthThree !== "4" && monthTwo !== "4" && (
                    <option value="4">Avril</option>
                  )}
                  {monthThree !== "5" && monthTwo !== "5" && (
                    <option value="5">Mai</option>
                  )}
                  {monthThree !== "6" && monthTwo !== "6" && (
                    <option value="6">Juin</option>
                  )}
                  {monthThree !== "7" && monthTwo !== "7" && (
                    <option value="7">Juillet</option>
                  )}
                  {monthThree !== "8" && monthTwo !== "8" && (
                    <option value="8">Août</option>
                  )}
                  {monthThree !== "9" && monthTwo !== "9" && (
                    <option value="9">Septembre</option>
                  )}
                  {monthThree !== "10" && monthTwo !== "10" && (
                    <option value="10">Octobre</option>
                  )}
                  {monthThree !== "11" && monthTwo !== "11" && (
                    <option value="11">Novembre</option>
                  )}
                  {monthThree !== "12" && monthTwo !== "12" && (
                    <option value="12">Décembre</option>
                  )}
                </Form.Select>
              </Form.Group>
            </div>
            {/* <JC {x ? y : z} */}
            {monthTwo ? 
              <div className="col-md-2">
              <Form.Group controlId={`select-month-two`}>
                <Form.Select
                  size="lg"
                  disabled={monthOne ? false : true}
                  value={monthTwo}
                  name="monthTwo"
                  onChange={(e) => {
                    if ("" === e.target.value) {
                      setMonthThree("");
                    }
                    handleInputChange(e);
                    setMonthTwo(e.target.value);
                  }}
                >
                  <option value="">Mois 2</option>
                  {monthOne !== "1" && monthThree !== "1" && (
                    <option value="1">Janvier</option>
                  )}
                  {monthOne !== "2" && monthThree !== "2" && (
                    <option value="2">Février</option>
                  )}
                  {monthOne !== "3" && monthThree !== "3" && (
                    <option value="3">Mars</option>
                  )}
                  {monthOne !== "4" && monthThree !== "4" && (
                    <option value="4">Avril</option>
                  )}
                  {monthOne !== "5" && monthThree !== "5" && (
                    <option value="5">Mai</option>
                  )}
                  {monthOne !== "6" && monthThree !== "6" && (
                    <option value="6">Juin</option>
                  )}
                  {monthOne !== "7" && monthThree !== "7" && (
                    <option value="7">Juillet</option>
                  )}
                  {monthOne !== "8" && monthThree !== "8" && (
                    <option value="8">Août</option>
                  )}
                  {monthOne !== "9" && monthThree !== "9" && (
                    <option value="9">Septembre</option>
                  )}
                  {monthOne !== "10" && monthThree !== "10" && (
                    <option value="10">Octobre</option>
                  )}
                  {monthOne !== "11" && monthThree !== "11" && (
                    <option value="11">Novembre</option>
                  )}
                  {monthOne !== "12" && monthThree !== "12" && (
                    <option value="12">Décembre</option>
                  )}
                </Form.Select>
              </Form.Group>
              </div>
            : ''}
            {/* JC> */}
            {/* <JC {x ? y : z} */}
            {monthThree ? 
              <div className="col-md-2">
                <Form.Group controlId={`select-month-three`}>
                  <Form.Select
                    size="lg"
                    disabled={monthOne && monthTwo ? false : true}
                    value={monthThree}
                    name="monthThree"
                    onChange={(e) => {
                      handleInputChange(e);
                      setMonthThree(e.target.value);
                    }}
                  >
                    <option value="">Mois 3</option>
                    {monthOne !== "1" && monthTwo !== "1" && (
                      <option value="1">Janvier</option>
                    )}
                    {monthOne !== "2" && monthTwo !== "2" && (
                      <option value="2">Février</option>
                    )}
                    {monthOne !== "3" && monthTwo !== "3" && (
                      <option value="3">Mars</option>
                    )}
                    {monthOne !== "4" && monthTwo !== "4" && (
                      <option value="4">Avril</option>
                    )}
                    {monthOne !== "5" && monthTwo !== "5" && (
                      <option value="5">Mai</option>
                    )}
                    {monthOne !== "6" && monthTwo !== "6" && (
                      <option value="6">Juin</option>
                    )}
                    {monthOne !== "7" && monthTwo !== "7" && (
                      <option value="7">Juillet</option>
                    )}
                    {monthOne !== "8" && monthTwo !== "8" && (
                      <option value="8">Août</option>
                    )}
                    {monthOne !== "9" && monthTwo !== "9" && (
                      <option value="9">Septembre</option>
                    )}
                    {monthOne !== "10" && monthTwo !== "10" && (
                      <option value="10">Octobre</option>
                    )}
                    {monthOne !== "11" && monthTwo !== "11" && (
                      <option value="11">Novembre</option>
                    )}
                    {monthOne !== "12" && monthTwo !== "12" && (
                      <option value="12">Décembre</option>
                    )}
                  </Form.Select>
                </Form.Group>
              </div>
            : ''}
            {/* JC> */}
            {errorMessageMonths && (
              <div className="col-md-12 mt-3 p-1 text-center">
                <Alert variant="danger" className="m-0">
                  {errorMessageMonths}
                </Alert>
              </div>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-5">
              <Form.Group>
                <Form.Label>Offre</Form.Label>
                <Form.Select
                  disabled={selectOperation === "" ? true : false}
                  size="lg"
                  value={selectOffre}
                  name="selectOffre"
                  onChange={(e) => {
                    handleInputChange(e);
                    setDescriptionOtherOffer("");
                    setSelectOffre(e.target.value);
                  }}
                  required
                >
                  <option value="">Sélectionnez une offre</option>
                  {state.operationsType.filter(
                    (elt) => elt.id.toString() === selectOperation
                  )[0] &&
                  state.operationsType.filter(
                    (elt) => elt.id.toString() === selectOperation
                  )[0].operation_descriptions.length > 0
                    ? state.operationsType
                        .filter(
                          (elt) => elt.id.toString() === selectOperation
                        )[0]
                        .operation_descriptions.map((opeDescription, key) => (
                          <option key={key} value={opeDescription.id}>
                            {opeDescription.name}
                          </option>
                        ))
                    : ""}
                  <option value="autre">Autre</option>
                </Form.Select>
                {selectOffre === "autre" && (
                  <Form.Control
                    required
                    className="mt-3"
                    as="textarea"
                    placeholder="Offre descriptif"
                    value={descriptionOtherOffer}
                    name="descriptionOtherOffer"
                    onChange={(e) => {
                      handleInputChange(e);
                      setDescriptionOtherOffer(e.target.value);
                    }}
                  />
                )}
              </Form.Group>
              {/* <JC
              <Form.Group className="mt-5">
                <Form.Label>Prestataire</Form.Label>
                <Form.Select
                  disabled={selectOperation === "" ? true : false}
                  size="lg"
                  value={selectPrestataire}
                  name="selectPrestataire"
                  onChange={(e) => {
                    handleInputChange(e);
                    setSelectPrestataire(e.target.value);
                  }}
                >
                  <option value="">Sélectionnez un prestataire</option>
                  {state.listPrestataires.length > 0 &&
                    state.listPrestataires.map((presta, key) => (
                      <option key={key} value={presta.id}>
                        {presta.name}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
                  JC> */}
              <Form.Group className="mt-5">
                <Form.Label>Animations</Form.Label><br />
                <Form.Text className="">{animationsOperation}</Form.Text>
              </Form.Group>
            </div>
            <div className="d-none">
              <Form.Group className="min-height">
                {/* <JC <Form.Label>Outils de communication</Form.Label> JC> */}
                {state.listComTools.map((comTool, key) => (
                  <Form.Check
                    key={key}
                    type="switch"
                    disabled={
                      (operationCommunicationToolsData.length >= 5) &
                        !isCheckedComTool[key] ||
                      state.operationsType.length === 0
                        ? true
                        : false
                    }
                    className={isCheckedComTool[key] ? "blue" : ""}
                    checked={isCheckedComTool[key]}
                    id={`comtools-switch-${key}`}
                    required
                    label={comTool.name}
                    readOnly
                    value={isCheckedComTool[key]}
                    name="isCheckedComTool"
                    onClick={(e) => {
                      handleInputChange(e, key);
                      handleOnChangeComTool(key);
                    }}
                  />
                ))}
              </Form.Group>
            </div>
            <div className="col-md-5">
              <Form.Group className="min-height">
                <Form.Label>Merchandising</Form.Label>
                <div className="row align-items-center ">
                  <div className="col-md-8">
                    {listPlvs.map((tPlv, key) => (
                      <Form.Check
                        key={key}
                        type="switch"
                        disabled={ true/*
                          (operationMerchandisingData.length >= 6 &&
                            !isCheckedMerchandising[key]) ||
                          state.operationsType.length === 0
                            ? true
                            : false*/
                        }
                        className={isCheckedMerchandising[key] ? "blue" : ""}
                        checked={isCheckedMerchandising[key]}
                        id={`typeplv-switch-${tPlv.operation_plv_type.name}`}
                        required
                        label={tPlv.operation_plv_type.name}
                        readOnly
                        name="isCheckedMerchandising"
                        value={isCheckedMerchandising[key]}
                        onClick={(e) => {
                          handleInputChange(e, key, tPlv.id);
                          handleOnChangeMerchandising(key);
                        }}
                      />
                    ))}
                  </div>
                  <div className="col-md-1">
                  
                    {listPlvs.map((tPlv, key) => (
                      <Form.Control
                        key={key}
                        type="hidden"
                        required
                        disabled={!isCheckedMerchandising[key]}
                        value={
                          isCheckedMerchandising[key]
                            ? operationMerchandisingData.filter(
                                (elt) => elt.operation_plv_id === tPlv.id
                              )[0].quantity
                            : ""
                        }
                        name="operationMerchandisingData"
                        onChange={(e) => {
                          handleInputChange(e, tPlv.id);
                          handleQuantityMerchandising(
                            tPlv.id,
                            parseInt(e.target.value)
                          );
                        }}
                        placeholder={tPlv.quantity_max}
                        max={tPlv.quantity_max}
                        min={1}
                        className="mb-2"
                      />
                    ))}
                  </div>
                  
                </div>
                
              </Form.Group>
            </div>
            {/* <JC */}
            <div className="col-md-2">
                <Form.Label>Prestataire</Form.Label>
                {listPlvs.map((tPlv, key) => (

                  <div key={key} style={{height:40}}>
                    {isCheckedMerchandising[key]
                    ? operationMerchandisingData.filter(
                        (elt) => elt.operation_plv_id === tPlv.id
                      )[0].provider
                    : ""}
                  </div>
                ))}
              </div>
              {/* JC> */}
          </div>
          <div className="row">
            <div className="col-md-8">
              <Form.Group>
                <Form.Label>Commentaire</Form.Label>
                <Form.Control
                  disabled={state.operationsType.length === 0 ? true : false}
                  as="textarea"
                  placeholder="Laissez votre commentaire ici..."
                  value={commentOperation ? commentOperation : ""}
                  name="commentOperation"
                  onChange={(e) => {
                    handleInputChange(e);
                    setCommentOperation(e.target.value);
                  }}
                  style={{ height: "100px" }}
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="is-bottom-right">
          <Button
            variant="secondary"
            className="button grey-dark-button"
            onClick={handleClose}
          >
            Annuler
          </Button>
          <Button
            type="submit"
            disabled={state.operationsType.length === 0 ? true : false}
            className="button green-button"
          >
            {controlFormId.includes("update") ? "Modifier" : "Ajouter"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default OperationModalRegisterOrUpdate;
